/**
 * Application route constants.
 */
export const ROUTES = {
  HOME: "/",
  WAITLIST: "/waitlist",
  CONTACT_US: "/contact-us",
  PRIVACY_POLICY: "/privacy",
  TERMS_AND_CONDITIONS: "/terms-of-service",
  ADMIN: "/admin",
  ADMIN_LOGIN: "/admin/login",
  ADMIN_USERS: "/admin/users",
  ADMIN_SUBSCRIPTIONS: "/admin/subscriptions",
  ADMIN_SUBSCRIPTIONS_WEBHOOKS: "/admin/subscriptions/webhooks",
  ADMIN_REFERRALS: "/admin/referrals",
  ADMIN_BROKEN_LINKS: "/admin/broken-links",
  ADMIN_CONTENT_HEALTH: "/admin/content-health",
  ADMIN_SYNC_TEAMS_AND_PLAYERS: "/admin/sync-teams-and-players",
  ADMIN_SYNC_MATCHES: "/admin/sync-matches",
  ADMIN_SYNC_OTT_HIGHLIGHTS: "/admin/sync-ott-highlights",
  ADMIN_PLATFORMS_OTT: "/admin/platforms/ott",
  ADMIN_PLATFORMS_YOUTUBE: "/admin/platforms/youtube",
  ADMIN_PLATFORMS_HIGHLIGHT_SOURCE: "/admin/platforms/highlight-source",
  ADMIN_PLATFORMS_TOP_PLAYERS: "/admin/platforms/top-players",
  ADMIN_STREAMING_PLATFORMS: "/admin/streaming-platforms",
  ADMIN_ROLES: "/admin/roles",
  ADMIN_SETTINGS: "/admin/settings",
  ADMIN_ALERTS: "/admin/alerts",
  ADMIN_NOTIFICATIONS_ANNOUNCEMENT: "/admin/notifications/announcement",
  UNAUTHORIZED: "/unauthorized",
  FORBIDDEN: "/forbidden",
} as const;

/** Public routes that do not require authentication. */
export const PUBLIC_ROUTES = [
  ROUTES.HOME,
  ROUTES.WAITLIST,
  ROUTES.CONTACT_US,
  ROUTES.PRIVACY_POLICY,
  ROUTES.TERMS_AND_CONDITIONS,
  "/reference",
] as const;

/** Admin routes accessible without an authenticated admin session. */
export const ADMIN_PUBLIC_ROUTES = [ROUTES.ADMIN_LOGIN] as const;

/** Admin routes that will require authentication. */
export const ADMIN_ROUTE_PREFIX = "/admin";
